<template>
  <el-menu
    class="navbar"
    mode="horizontal">
    <el-button
      @click="handleSignout"
      size="small">
      {{ handleCommon('setting.signout') }} {{ this.$store.state.signin.name }}
    </el-button>
  </el-menu>
</template>

<script>
import common from '@/utils/common'

export default {
  methods: {
    handleCommon(k) {
      return k.split('.').reduce((a, c) => a[c], common)
    },
    handleSignout() {
      this.$store.dispatch('signin/SignOut').then(res => {
        this.$message.success(common.message.signoutSuccess)
        this.$router.push({ path: '/signin' })
      }).catch(err => {
        this.$message.error(err.response.data.message)
      })
    }
  }
}
</script>
